import {Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {UserService} from '../../service/user.service';
import {catchError, filter, finalize, forkJoin, interval, map, of, Subject, switchMap, takeUntil, tap, timer} from "rxjs";
import {StorageKeys} from "../../shared/enums/storage-keys.enum";
import {RoutesEnum} from "../../shared/enums/routes.enum";
import {TriagemService} from "../../service/triagem.service";
import {LoaderService} from "../../service/loader.service";
import {environment} from "../../../environments/environment";
import {Router} from "@angular/router";
import {TriagemCountReservadas} from "../../models/triagem-count-reservadas.model";
import {OverlayPanel} from "primeng/overlaypanel";
import {ContratoTriagem} from "../../models/contrato-triagem.model";
import {ThemeService} from "../../service/theme.service";
import {RoleEnum} from "../../shared/enums/role.enum";
import { GroupEnum } from '../../shared/enums/group.enum';
import { AlertService } from 'src/app/service/alert.service';
import { ListenerMessage } from 'src/app/shared/tools/message';
import { RabbitMQService } from 'src/app/service/rabbit-mq.service';
import { EquipmentAlertType } from 'src/app/shared/enums/equipment-alert-type.enum';
import { EquipmentAlertSeverity } from 'src/app/shared/enums/equipment-alert-severity.enum';
import {GA4Service} from "../../service/ga4.service";
import {TriagemPassagemService} from "../../service/triagem-passagem.service";
import {UserTypeEnum} from '../../shared/enums/user-type.enum';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
  @ViewChild('opMenu') overlayPanel!: OverlayPanel;
  private readonly _destroy$: Subject<void> = new Subject<void>();
  private alertAudio?: HTMLAudioElement;
  private alertSoundUnlocked: boolean = false;
  private lastAlertSoundAt: number = 0;
  notixAppId = '100595b66642e265aba1a22a1520933';
  showNotixPixel = true;
  menuOverlayVisible = false;
  visibleSidebar = false;
  role = RoleEnum;
  userName: any = ''
  menuItensSideMenu: MenuItem[] = [];
  version: string = environment.version;
  showReservadasIcon: boolean = true;
  showReservadasPassagemIcon: boolean = true;
  email: string = '';
  badgeCount: number = 0;
  alertPanelOpen: boolean = false;
  alertBlinking: boolean = false;
  showMenu: boolean = true;
  private polling: any;

  userMenuActions: MenuItem[] = [
    {label: 'Alterar senha', icon: 'pi pi-key', routerLink: 'change-password', command: () => this.overlayPanel.hide()},
    {
      label: 'Sobre',
      icon: 'pi pi-fw pi-info-circle',
      url: 'https://velsis.com.br/',
      target: '_blank',
      tooltipOptions: {
        tooltipLabel: 'Você será redirecionado para velsis.com.br',
        tooltipPosition: 'left'
      },
      command: () => this.overlayPanel.hide(),
    },
    {label: 'Sair', icon: 'pi pi-fw pi-sign-out', command: () => this.logout()},
  ];
  iconMenuActions: MenuItem[] = [];
  iconMenuActionsPassagem: MenuItem[] = [];
  menuOptions: MenuItem[] = [];
  possueTriagemReservada: boolean = false;
  possueTriagemPassagemReservada: boolean = false;
  usuariosDaSessao: Map<ContratoTriagem, any[]> = new Map();
  showSidebarUsuariosLogados: boolean = false;
  possueUsuariosLogados: number = 0;
  contratoUsuariosSelecionado?: ContratoTriagem;
  contratoUsuarioOptions: any[] = [];

  contratoOptions: any[] = [];
  contratoSelecionado: any;
  equipmentAlertType = EquipmentAlertType;
  equipmentAlertSeverity = EquipmentAlertSeverity;
  //MOCK DOS ALERTAS
  alerts: any = [];


  constructor(public userService: UserService,
              public loaderService: LoaderService,
              public messageService: MessageService,
              public route: Router,
              public confirmationService: ConfirmationService,
              private alertService: AlertService,
              public themeService: ThemeService,
              private  rabbitService: RabbitMQService,
              public triagemService: TriagemService,
              public triagemPassagemService: TriagemPassagemService,
              private ga4Service: GA4Service) {
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
    if (this.polling) {
      clearInterval(this.polling);
    }
    if (this.alertAudio) {
      this.alertAudio.pause();
      this.alertAudio = undefined;
    }
  }

  ngOnInit() {
    if(this.userService.getCurrentContract()?.id===GroupEnum.PRF) this.listAlerts();
    this.subscribeUsuariosDaSessao()
    this.setContratoOptions();
    this.setUsuario();
    this.setEmail();
    this.buildModelMenu();
    this.triagemService.contractsAlreadyLoaded$
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (loaded: boolean) => {
          if (loaded) {
            this.generateNotificationMenu();
          }
        }
      })
    this.subscribeReservaDeTriagem();
    this.subscribeReservaDeTriagemPassagem();
    this.themeService.selectedApp$.subscribe({
      next: () => this.buildModelMenu()
    })

    this.polling = setInterval(() => {
      const group = localStorage.getItem('group');
      if (group) {
        const parsedGroup = JSON.parse(group);
        if (JSON.stringify(parsedGroup.name) !== JSON.stringify(this.contratoSelecionado.name)) {
          this.contratoSelecionado = parsedGroup;
          window.location.reload();
        }
      }
    }, 500);
  }

  private setContratoOptions() {
    this.contratoSelecionado = this.userService.getCurrentContract();
    this.contratoOptions = []
    let currentUser = this.userService.user;
    if (!currentUser.contracts) {
      return;
    }
    currentUser.contracts?.forEach(contract => {
      this.contratoOptions.push({
        label: contract.name,
        value: contract,
      })
    })
    console.log(this.contratoOptions);
  }

  handleContratoChange(event: any) {
    this.loaderService.showLoader();
    this.userService.setCurrentContract(this.contratoSelecionado);
    this.refreshNotificationMenu(this.triagemService.cacheContratos$.value);

    // acesso a contrato (troca de contrato pelo menu) - analytics
    this.ga4Service.trackUserAccess();

    this.themeService.reloadNexus$.next(true);
    this.buildModelMenu();
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.route.navigate(['/pages/multi-apps']).then(() => {
      });
    });
    setTimeout(() => {
      this.loaderService.hideLoader();
    }, 1000)
  }

  subscribeReservaDeTriagem() {
    this.triagemService.efetuouReservaDeTriagem
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: () => {
          this.listAllReservations();
        }
      });
  }

  subscribeReservaDeTriagemPassagem() {
    this.triagemPassagemService.efetuouReservaDeTriagem
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: () => {
          this.listAllReservationsPassagem();
        }
      });
  }

  setUsuario() {
    this.userName = this.userService.user.userName;
  }

  setEmail() {
    this.email = localStorage.getItem(StorageKeys.USER_EMAIL) ?? '';
    if (this.email.length > 0) {
      this.showNotixPixel = true;
    }
  }

  closeSideMenu() {
    this.menuItensSideMenu.forEach(menu => {
      if (menu.items)
        menu.expanded = false;
    });
    this.visibleSidebar = false;
    this.showMenu = false;
    setTimeout(() => this.showMenu = true, 10);
  }

  callCommand(menuItem: MenuItem) {
    if (menuItem.command)
      menuItem.command({item: menuItem})
  }

  buildModelMenu() {

    this.menuItensSideMenu = [
      {
        label: `<img width="50%" src="/assets/images/logo.png" alt="Logo da empresa"/>`,
        styleClass: 'mt-3',
        escape: false,
        command: () => {
          this.closeSideMenu();
          if(this.route.url !== RoutesEnum.DASHBOARD_SERVICOS){
            setTimeout(()=> {
              this.goToSelectApp();
            }, 80);
          }
        },
      },
      //------ TELAS DO PRODUTOS DO NEXUS ------
      {
        label: `
        <div class="flex align-items-center" style="cursor: pointer !important;">
          <img src="assets/images/tracker/logotrackersf.png" width="100" height="auto">
        </div>
        `,
        escape: false,
        expanded: false,
        visible: /*this.themeService.selectedApp === `tracker` && */this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.TRACKER_VS, RoleEnum.TRACKER_VS_GENERAL, RoleEnum.TRACKER_VS_INTERVAL, RoleEnum.TRACKER_VS_ANALYSIS]),
        items: [
          {
            label: 'Geral',
            icon: 'pi pi-chart-line',
            routerLink: [RoutesEnum.TRACKERVS_GENERAL],
            visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.TRACKER_VS, RoleEnum.TRACKER_VS_GENERAL]),
            command: () => this.closeSideMenu(),
          },
          {
            label: 'Intervalo',
            icon: 'pi pi-clock',
            routerLink: [RoutesEnum.TRACKERVS_INTERVAL],
            visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.TRACKER_VS, RoleEnum.TRACKER_VS_INTERVAL]),
            command: () => this.closeSideMenu(),
          },
          {
            label: 'Análise',
            icon: 'pi pi-chart-bar',
            routerLink: [RoutesEnum.TRACKERVS_ANALYSIS],
            visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.TRACKER_VS, RoleEnum.TRACKER_VS_ANALYSIS]),
            command: () => this.closeSideMenu(),
          },
        ]
      },
      {
        label: 'Pulse VS',
        icon: 'pi pi-fw pi-desktop',
        expanded: false,
        visible: /*this.themeService.selectedApp !== `tracker` && */this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.TEMPO_REAL_MAP, RoleEnum.OCORRENCIA]),
        items: [
          {
            label: 'Tempo real',
            icon: 'pi pi-fw pi-clock',
            routerLink: [RoutesEnum.REAL_TIME],
            visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.TEMPO_REAL_MAP]),
            command: () => this.closeSideMenu(),
          },
          {
            label: 'Motivo Ocorrência',
            icon: 'pi pi-arrow-circle-right',
            routerLink: [RoutesEnum.MONITORING_MOTIVE_OCCURRENCE],
            visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.OCORRENCIA]),
            command: () => this.closeSideMenu(),
          },
          {
            label: 'Ocorrência',
            icon: 'pi pi-history',
            routerLink: [RoutesEnum.MONITORING_OCCURRENCE],
            visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.OCORRENCIA]),
            command: () => this.closeSideMenu(),
          },
          {
            label: 'Início de Operação',
            icon: 'pi pi-play',
            routerLink: [RoutesEnum.MONITORING_EQUIPMENT_OPERATION_START],
            visible:
              this.userService.canActivateByUserType([UserTypeEnum.ADMIN]) ||
              this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.EQUIPMENT_OPERATION_START]),
            command: () => this.closeSideMenu(),
          },
          {
            label: 'Alertas',
            icon: 'pi pi-exclamation-triangle',
            routerLink: [RoutesEnum.EQUIPMENT_ALERT],
            visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.EQUIPMENT_ALERT]),
            command: () => this.closeSideMenu(),
          },
          
        ],
      },
      {
        label: 'Processamento',
        icon: 'pi pi-database',
        expanded: false,
          visible:
            this.userService.canActivateByUserType([UserTypeEnum.ADMIN, UserTypeEnum.SUS]) ||
            this.userService.hasPermission([
              RoleEnum.ADMIN_FULL,
              RoleEnum.GESTOR,
              RoleEnum.PROCESSAMENTO_PRE_TRIAGEM,
              RoleEnum.PROCESSAMENTO_TRIAGEM,
              RoleEnum.PROCESSAMENTO_TRIAGEM_SEGUNDA,
              RoleEnum.PROCESSAMENTO_TRIAGEM_VALIDACAO,
              RoleEnum.PROCESSAMENTO_TRIAGEM_HISTORICO,
              RoleEnum.PROCESSAMENTO_TRIAGEM_HISTORICO,
              RoleEnum.PROCESSAMENTO_TRIAGEM_BATCH,
              RoleEnum.EXPORTACAO
            ]),
          items: [
            {
              label: 'Pré Triagem',
              icon: 'pi pi-filter',
              routerLink: [RoutesEnum.PROCESSAMENTO_PRE_TRIAGEM],
              visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.PROCESSAMENTO_PRE_TRIAGEM]),
              command: () => {
                this.closeSideMenu();
                this.loaderService.showLoader();
                setTimeout(() => this.loaderService.hideLoader(), 300);
              },
            },
            {
              label: 'Triagem',
              icon: 'pi pi-filter',
              routerLink: [RoutesEnum.PROCESSAMENTO_PRIMEIRA_TRIAGEM],
              visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.PROCESSAMENTO_TRIAGEM_PRIMEIRA, RoleEnum.PROCESSAMENTO_TRIAGEM_BATCH]),
              command: () => {
                this.closeSideMenu();
                this.loaderService.showLoader();
                setTimeout(() => this.loaderService.hideLoader(), 300);
              },
            },
            {
              label: 'Segunda Triagem',
              icon: 'pi pi-filter',
              routerLink: [RoutesEnum.PROCESSAMENTO_SEGUNDA_TRIAGEM],
              visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.PROCESSAMENTO_TRIAGEM_SEGUNDA]),
              command: () => {
                this.closeSideMenu();
                this.loaderService.showLoader();
                setTimeout(() => this.loaderService.hideLoader(), 300);
              },
            },
            {
              label: 'Validação',
              icon: 'pi pi-filter',
              routerLink: [RoutesEnum.PROCESSAMENTO_VALIDACAO_TRIAGEM],
              visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.PROCESSAMENTO_TRIAGEM_VALIDACAO]),
              command: () => {
                this.closeSideMenu();
                this.loaderService.showLoader();
                setTimeout(() => this.loaderService.hideLoader(), 300);
              },
            },
            {
              label: 'Histórico',
              icon: 'pi pi-filter',
              routerLink: [RoutesEnum.PROCESSAMENTO_HISTORICO_TRIAGEM],
              visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.PROCESSAMENTO_TRIAGEM_HISTORICO]),
              command: () => {
                this.closeSideMenu();
                this.loaderService.showLoader();
                setTimeout(() => this.loaderService.hideLoader(), 300);
              },
            },
            // {
            //   label: 'Triagem Passagem',
            //   icon: 'pi pi-filter',
            //   routerLink: [RoutesEnum.PROCESSAMENTO_PASSAGEM_PRIMEIRA_TRIAGEM],
            //   visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.PROCESSAMENTO_TRIAGEM_PRIMEIRA, RoleEnum.PROCESSAMENTO_TRIAGEM_BATCH]),
            //   command: () => {
            //     this.closeSideMenu();
            //     this.loaderService.showLoader();
            //     setTimeout(() => this.loaderService.hideLoader(), 300);
            //   },
            // },
            {
              label: 'Veículos Isentos',
              icon: 'pi pi-car',
              routerLink: [RoutesEnum.PROCESSAMENTO_VEICULOS_ISENTOS],
              visible: environment.features.crud_isentos && this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR]),
              command: () => {
                this.closeSideMenu();
                this.loaderService.showLoader();
                setTimeout(() => this.loaderService.hideLoader(), 300);
              },
            },
            {
              label: 'Exportação AIT',
              icon: 'pi pi-file',
              routerLink: [RoutesEnum.EXPORTACAO_LISTAGEM_AIT],
              visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.EXPORTACAO]),
              command: () => this.closeSideMenu(),
            },
            {
              label: 'Lote exportado AIT',
              icon: 'pi pi-file',
              routerLink: [RoutesEnum.EXPORTACAO_LOTE_EXPORTADO_AIT],
              visible: this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.EXPORTACAO]),
              command: () => this.closeSideMenu(),
            },
            {
              label: 'Exportação Placas',
              icon: 'pi pi-file',
              routerLink: [RoutesEnum.EXPORTACAO_LISTAGEM_PLACAS, RoleEnum.EXPORTACAO],
              visible: false,
              command: () => this.closeSideMenu(),
            },
            {
              label: 'Lote exportado Placas',
              icon: 'pi pi-file',
              routerLink: [RoutesEnum.EXPORTACAO_LOTE_EXPORTADO_PLACAS, RoleEnum.EXPORTACAO],
              visible: false,
              command: () => this.closeSideMenu(),
            },
            {
              label: 'Sincronização',
              icon: 'pi pi-sync',
              routerLink: [RoutesEnum.SYNC_DIFF],
              visible: this.userService.user.userType == 'SUS' || this.userService.user.userType == 'ADM',
              command: () => this.closeSideMenu(),
            },
            {
              label: 'Monitoramento de Vídeo',
              icon: 'pi pi-video',
              routerLink: [RoutesEnum.MONITORING_EQUIPMENT_VIDEO],
              visible: this.userService.user.userType == 'SUS' || this.userService.user.userType == 'ADM' || this.userService.user.userType == 'OPR',
              command: () => this.closeSideMenu(),
            },
          ]
        },
    ];
  }

  logout() {
    this.overlayPanel.hide();
    this.closeSideMenu();
    this.userService.efetuarLogout();
  }
  
  confirmarLiberarReservadas(contrato: ContratoTriagem) {
    this.confirmationService.confirm({
      message: `Deseja realmente liberar todas as infrações reservadas do contrato de ${contrato.descricao}?`,
      header: 'Confirmar', key: 'headerMenuConfirmDialog',
      rejectLabel: 'Cancelar', acceptLabel: 'Confirmar',
      rejectButtonStyleClass: 'p-button-outlined mr-3',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.liberarReservadas(contrato);
        this.overlayPanel.hide();
      }
    });
  }

  liberarReservadas(contrato: ContratoTriagem) {
    this.loaderService.showLoader();
    this.triagemService.releaseReservations(
      contrato.id ?? -1,
      contrato.userId ?? -1
    ).pipe(takeUntil(this._destroy$))
      .pipe(finalize(() => this.loaderService.hideLoader()))
      .subscribe({
        next: () => {
          this.showReservadasIcon = false;
          this.triagemService.clearAvaliarDepois(contrato.userId ?? -1, contrato.id ?? -1);
          this.messageService.add({
            key: 'toastMenuHeader',
            severity: 'success',
            detail: 'Reservas liberadas com sucesso',
          });
          setTimeout(() => this.showReservadasIcon = true, 2);
          this.trataRotaTriagem(contrato, true);
        },
        error: () => {
          this.messageService.add({
            key: 'toastMenuHeader',
            severity: 'error',
            detail: 'Ocorreu um erro na liberação das infrações reservas',
          })
        },
      })
  }

  confirmarLiberarReservadasPassagem(contrato: ContratoTriagem) {
    this.confirmationService.confirm({
      message: `Deseja realmente liberar todas as passagens reservadas do contrato de ${contrato.descricao}?`,
      header: 'Confirmar', key: 'headerMenuConfirmDialog',
      rejectLabel: 'Cancelar', acceptLabel: 'Confirmar',
      rejectButtonStyleClass: 'p-button-outlined mr-3',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.liberarReservadasPassagem(contrato);
        this.overlayPanel.hide();
      }
    });
  }

  liberarReservadasPassagem(contrato: ContratoTriagem) {
    this.loaderService.showLoader();
    this.triagemPassagemService.releaseReservations(
      contrato.id ?? -1,
      contrato.userId ?? -1
    ).pipe(takeUntil(this._destroy$))
      .pipe(finalize(() => this.loaderService.hideLoader()))
      .subscribe({
        next: () => {
          this.showReservadasPassagemIcon = false;
          this.triagemPassagemService.clearAvaliarDepois(contrato.userId ?? -1, contrato.id ?? -1);
          this.messageService.add({
            key: 'toastMenuHeader',
            severity: 'success',
            detail: 'Reservas de passagem liberadas com sucesso',
          });
          setTimeout(() => this.showReservadasPassagemIcon = true, 2);
          this.trataRotaTriagemPassagem(contrato, true);
        },
        error: () => {
          this.messageService.add({
            key: 'toastMenuHeader',
            severity: 'error',
            detail: 'Ocorreu um erro na liberação das passagens reservadas',
          })
        },
      })
  }

  trataRotaTriagem(contrato?: ContratoTriagem, forceRefreshList?: boolean) {
    if (contrato && this.triagemService.triagemFilterSelecionada.value?.userId !== contrato.userId)
      return;

    const estaEfetuandoPreTriagem = [
      RoutesEnum.PROCESSAMENTO_PRE_TRIAGEM_PROCESSAR.toString(),
    ].includes(this.route.url);

    const estaEfetuandoPrimeiraTriagem = [
      RoutesEnum.PROCESSAMENTO_PRIMEIRA_TRIAGEM_PROCESSAR.toString(),
      RoutesEnum.PROCESSAMENTO_PRIMEIRA_TRIAGEM_EM_LOTE.toString()
    ].includes(this.route.url);

    const estaEfetuandoSegundaTriagem = [
      RoutesEnum.PROCESSAMENTO_SEGUNDA_TRIAGEM_PROCESSAR.toString()
    ].includes(this.route.url);

    const estaEfetuandoValidacaoTriagem = [
      RoutesEnum.PROCESSAMENTO_VALIDACAO_TRIAGEM_PROCESSAR.toString()
    ].includes(this.route.url);

    const estaEfetuandoHistoricoTriagem = [
      RoutesEnum.PROCESSAMENTO_HISTORICO_TRIAGEM_PROCESSAR.toString()
    ].includes(this.route.url);

    if (estaEfetuandoPrimeiraTriagem) {
      this.route.navigate(['/pages/triagem/navigate-back/primeira']);
    } else if (estaEfetuandoPreTriagem) {
      this.route.navigate(['/pages/triagem/navigate-back/pretriagem']);
    } else if (estaEfetuandoSegundaTriagem) {
      this.route.navigate(['/pages/triagem/navigate-back/segunda']);
    } else if (estaEfetuandoValidacaoTriagem) {
      this.route.navigate(['/pages/triagem/navigate-back/validacao']);
    } else if (estaEfetuandoHistoricoTriagem) {
      this.route.navigate(['/pages/triagem/navigate-back/historico']);
    } else if (forceRefreshList) {
      if (this.route.url.includes('/pretriagem')) {
        this.reloadTriagemList('/pages/triagem/navigate-back/pretriagem');
      } else if (this.route.url.includes('/segunda')) {
        this.reloadTriagemList('/pages/triagem/navigate-back/segunda');
      } else if (this.route.url.includes('/validacao')) {
        this.reloadTriagemList('/pages/triagem/navigate-back/validacao');
      } else if (this.route.url.includes('/historico')) {
        this.reloadTriagemList('/pages/triagem/navigate-back/historico');
      } else if (this.route.url.includes('/primeira') || this.route.url.includes('/em-lote')) {
        this.reloadTriagemList('/pages/triagem/navigate-back/primeira');
      }
    }
  }

  trataRotaTriagemPassagem(contrato?: ContratoTriagem, forceRefreshList?: boolean) {
    if (contrato && this.triagemService.triagemFilterSelecionada.value?.userId !== contrato.userId)
      return;

    const estaEfetuandoPreTriagem = [
      RoutesEnum.PROCESSAMENTO_PASSAGEM_PRE_TRIAGEM_PROCESSAR.toString(),
    ].includes(this.route.url);

    const estaEfetuandoPrimeiraTriagem = [
      RoutesEnum.PROCESSAMENTO_PASSAGEM_PRIMEIRA_TRIAGEM_PROCESSAR.toString(),
      RoutesEnum.PROCESSAMENTO_PASSAGEM_PRIMEIRA_TRIAGEM_EM_LOTE.toString()
    ].includes(this.route.url);

    const estaEfetuandoSegundaTriagem = [
      RoutesEnum.PROCESSAMENTO_PASSAGEM_SEGUNDA_TRIAGEM_PROCESSAR.toString()
    ].includes(this.route.url);

    const estaEfetuandoValidacaoTriagem = [
      RoutesEnum.PROCESSAMENTO_PASSAGEM_VALIDACAO_TRIAGEM_PROCESSAR.toString()
    ].includes(this.route.url);

    const estaEfetuandoHistoricoTriagem = [
      RoutesEnum.PROCESSAMENTO_PASSAGEM_HISTORICO_TRIAGEM_PROCESSAR.toString()
    ].includes(this.route.url);

    if (estaEfetuandoPrimeiraTriagem) {
      this.route.navigate(['/pages/triagem-passagem/navigate-back/primeira']);
    } else if (estaEfetuandoPreTriagem) {
      this.route.navigate(['/pages/triagem-passagem/navigate-back/pretriagem']);
    } else if (estaEfetuandoSegundaTriagem) {
      this.route.navigate(['/pages/triagem-passagem/navigate-back/segunda']);
    } else if (estaEfetuandoValidacaoTriagem) {
      this.route.navigate(['/pages/triagem-passagem/navigate-back/validacao']);
    } else if (estaEfetuandoHistoricoTriagem) {
      this.route.navigate(['/pages/triagem-passagem/navigate-back/historico']);
    } else if (forceRefreshList) {
      if (this.route.url.includes('/pretriagem')) {
        this.reloadTriagemList('/pages/triagem-passagem/navigate-back/pretriagem');
      } else if (this.route.url.includes('/segunda')) {
        this.reloadTriagemList('/pages/triagem-passagem/navigate-back/segunda');
      } else if (this.route.url.includes('/validacao')) {
        this.reloadTriagemList('/pages/triagem-passagem/navigate-back/validacao');
      } else if (this.route.url.includes('/historico')) {
        this.reloadTriagemList('/pages/triagem-passagem/navigate-back/historico');
      } else if (this.route.url.includes('/primeira') || this.route.url.includes('/em-lote')) {
        this.reloadTriagemList('/pages/triagem-passagem/navigate-back/primeira');
      }
    }
  }

  private reloadTriagemList(route: string) {
  this.route.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.route.navigate([route]));
  }

  consultaInfracoesReservadas() {
    if (!this.userService.hasPermission([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.PROCESSAMENTO_TRIAGEM])) {
      return;
    }

    interval(60 * 1500)
      .pipe(
        tap(() => {
          this.listAllReservations();
          this.listAllReservationsPassagem();
        }),
        takeUntil(this._destroy$)
      )
      .subscribe({
        error: (err) => console.error('Error in reservation timer:', err),
        complete: () => {
        }
      });
  }

  listAllReservations() {
    if (this.triagemService.seguraConsultaReservadas.value)
      return;

    if (this.iconMenuActions.length === 0)
      return;

    this.showReservadasIcon = false;
    this.possueTriagemReservada = false
    const reservationRequests = this.iconMenuActions.map(menu => {
      const contrato = menu?.['data'] as ContratoTriagem;
      return this.triagemService.listReservations(contrato.id ?? -1, contrato.userId ?? -1)
        .pipe(
          takeUntil(this._destroy$),
          map((countReservadas: TriagemCountReservadas[]) => {
            return {reservadas: countReservadas, menu: menu, contrato: contrato};
          })
        );
    });

    forkJoin(reservationRequests).subscribe({
      next: (e: any[]) => {
        e.forEach((item: any) => {
          item.possueTriagemReservada = this.handleTriagemCountReservadas(item.reservadas, item.menu, item.contrato);
        });
        if (e.filter((item: any) => item.possueTriagemReservada).length === 0) {
          this.triagemService.clearAllAvaliarDepois();
          this.trataRotaTriagem();
        }
        setTimeout(() => this.showReservadasIcon = true, 2);
      }
    });
  }

  listAllReservationsPassagem() {
    if (this.triagemPassagemService.seguraConsultaReservadas.value)
      return;

    if (this.iconMenuActionsPassagem.length === 0)
      return;

    this.showReservadasPassagemIcon = false;
    this.possueTriagemPassagemReservada = false;
    const reservationRequests = this.iconMenuActionsPassagem.map(menu => {
      const contrato = menu?.['data'] as ContratoTriagem;
      return this.triagemPassagemService.listReservationsPassagem(contrato.id ?? -1, contrato.userId ?? -1)
        .pipe(
          takeUntil(this._destroy$),
          map((countReservadas: TriagemCountReservadas[]) => {
            return {reservadas: countReservadas, menu: menu, contrato: contrato};
          })
        );
    });

    forkJoin(reservationRequests).subscribe({
      next: (e: any[]) => {
        e.forEach((item: any) => {
          item.possueTriagemReservada = this.handleTriagemPassagemCountReservadas(item.reservadas, item.menu, item.contrato);
        });
        if (e.filter((item: any) => item.possueTriagemReservada).length === 0) {
          this.triagemPassagemService.clearAllAvaliarDepois();
          this.trataRotaTriagemPassagem();
        }
        setTimeout(() => this.showReservadasPassagemIcon = true, 2);
      }
    });
  }

    handleTriagemCountReservadas(countReservadas: TriagemCountReservadas[],
      menu: MenuItem,
      contrato: ContratoTriagem): boolean {
      let possueTriagemReservada = false;
      if (!!countReservadas && countReservadas.length > 0) {
      const merge = TriagemCountReservadas.merge(countReservadas);
      this.triagemService.updateAvaliarDepois(merge.reservedIds ?? [], contrato.userId ?? -1, contrato.id ?? -1);
      const totalReservadas = this.triagemService.getAvaliarDepois(contrato.userId ?? -1, contrato.id ?? -1);
      if (totalReservadas.length > 0) {
        possueTriagemReservada = true;
      }
      menu.badge = `${totalReservadas.length}`;
      menu.disabled = (totalReservadas.length ?? 0) === 0;
    }
    return possueTriagemReservada;
  }

  handleTriagemPassagemCountReservadas(countReservadas: TriagemCountReservadas[],
                                       menu: MenuItem,
                                       contrato: ContratoTriagem): boolean {
    let possueTriagemReservada = false;
    const merge = !!countReservadas && countReservadas.length > 0
      ? TriagemCountReservadas.merge(countReservadas)
      : undefined;
    const totalReservadas = this.triagemPassagemService.getAvaliarDepois(contrato.userId ?? -1, contrato.id ?? -1);
    console.log('[triagem-passagem][menu][handleTriagemPassagemCountReservadas:localOnly]', {
      contratoId: contrato.id,
      userId: contrato.userId,
      countReservadas,
      merge,
      totalReservadas,
    });
    if (totalReservadas.length > 0 || (merge?.reservedIds?.length ?? 0) > 0 || (merge?.totalReserved ?? 0) > 0) {
      possueTriagemReservada = true;
    }
    menu.badge = `${totalReservadas.length}`;
    menu.disabled = (totalReservadas.length ?? 0) === 0;
    return possueTriagemReservada;
  }

  generateNotificationMenu() {
    this.triagemService.cacheContratos$
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (contratos: ContratoTriagem[]) => {
          this.refreshNotificationMenu(contratos);
        }
      })
  }

  private refreshNotificationMenu(contratos: ContratoTriagem[]) {
    const currentContractId = this.userService.getCurrentContract()?.contractOriginId;
    const contratoAtual = contratos.find(contrato => contrato.id === currentContractId);

    this.iconMenuActions = [];
    this.iconMenuActionsPassagem = [];

    if (!contratoAtual)
      return;

    this.iconMenuActions.push({
      id: `${contratoAtual.id ?? -1}`,
      data: contratoAtual,
      label: `Liberar triagens reservadas (${contratoAtual.descricao})`,
      command: () => this.confirmarLiberarReservadas(contratoAtual)
    });
    this.iconMenuActionsPassagem.push({
      id: `${contratoAtual.id ?? -1}`,
      data: contratoAtual,
      label: `Liberar passagens reservadas (${contratoAtual.descricao})`,
      command: () => this.confirmarLiberarReservadasPassagem(contratoAtual)
    });

    this.listAllReservations();
    this.listAllReservationsPassagem();
    this.consultaInfracoesReservadas();
  }

  checkForceChangePassword() {
    const user = this.userService.user;
    return !!user.forceChangePassword;
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {
    this.overlayPanel.hide();
  }

  @HostListener('window:click')
  onWindowClick(): void {
    this.unlockAlertSound();
  }

  /**
   * NAO ALTERAR, NECESSARIO PARA O PRIMENG MENU
   * RENDERIZAR O MENU DE RESERVADAS ATUALIZADO.
   */
  setMenuOptionsTriagem() {
    // @ts-ignore
    this.menuOptions = undefined;
    this.iconMenuActions.push({title: 'mock'});
    this.iconMenuActions.pop();
    setTimeout(() => {
      this.menuOptions = this.iconMenuActions
        .sort((a, b) => parseInt((a.badge ?? '0'), 10) - parseInt((b.badge ?? '0'), 10))
        .reverse();
    }, 10)
  }

  setMenuOptionsTriagemPassagem() {
    // @ts-ignore
    this.menuOptions = undefined;
    this.iconMenuActionsPassagem.push({title: 'mock'});
    this.iconMenuActionsPassagem.pop();
    setTimeout(() => {
      this.menuOptions = this.iconMenuActionsPassagem
        .sort((a, b) => parseInt((a.badge ?? '0'), 10) - parseInt((b.badge ?? '0'), 10))
        .reverse();
    }, 10)
  }

  private subscribeUsuariosDaSessao() {
    this.userService.usuariosDaSessao$
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (usuarios: Map<ContratoTriagem, any[]>) => {
          this.usuariosDaSessao = new Map();
          this.contratoUsuariosSelecionado = undefined;
          this.contratoUsuarioOptions = [];
          this.possueUsuariosLogados = 0;
          if (usuarios) {
            this.usuariosDaSessao = usuarios;
            this.usuariosDaSessao.forEach((value, key) => {
              this.contratoUsuarioOptions.push({label: key.descricao, value: key});
              this.contratoUsuariosSelecionado ??= key;
              if (value?.length > 0) {
                this.possueUsuariosLogados = value.length + this.possueUsuariosLogados;
              }
            });
          }
        }
      })
  }

  showUsuariosLogados() {
    if (this.possueUsuariosLogados > 0) {
      this.showSidebarUsuariosLogados = true;
    }
  }

  goToSelectApp() {
    if (this.route.url === RoutesEnum.DASHBOARD_SERVICOS)
      window.location.reload();
    else
      this.route.navigate([RoutesEnum.DASHBOARD_SERVICOS]).then(() => {
      });
  }

  listAlerts() {
    this.rabbitService.subscribeToQueue((msg: any) => {
      // console.log(msg)
      // msg.alertType = this.getRandomAlertType(); //MOCK SOMENTE PARA TESTE LAYOUT
      // msg.severity = this.getRandomAlertSeverity() //MOCK SOMENTE PARA TESTE LAYOUT
      this.alerts.push(msg)
      if (!this.alertPanelOpen) {
        this.badgeCount = this.badgeCount + 1;
        this.alertBlinking = true;
        this.playAlertSound();
      }
    });
  }
  // INIT - FUNCOES MOCK SOMENTE PARA TESTE DE LAYOUT
  // private getRandomAlertType(): EquipmentAlertType {
  //   const types = Object.values(EquipmentAlertType);
  //   return types[Math.floor(Math.random() * types.length)];
  // }

  // private getRandomAlertSeverity(): EquipmentAlertSeverity {
  //   const types = Object.values(EquipmentAlertSeverity);
  //   return types[Math.floor(Math.random() * types.length)];
  // }
  //END

  getAlertSeverity(severity: string){
    switch (severity) {
      case EquipmentAlertSeverity.HIGH:
        return 'Crítico';
      case EquipmentAlertSeverity.MEDIUM:
        return 'Aviso';
      case EquipmentAlertSeverity.LOW:
        return 'Baixo';
      default:
        return 'Info';
  }
}

  private unlockAlertSound(): void {
    if (this.alertSoundUnlocked) {
      return;
    }
    this.alertAudio = new Audio('assets/audio/public_sounds_alerta-vanguard-critico.mp3');
    this.alertAudio.load();
    this.alertSoundUnlocked = true;
  }

  private playAlertSound(): void {
    if (!this.alertSoundUnlocked || !this.alertAudio) {
      return;
    }
    const now = Date.now();
    if (now - this.lastAlertSoundAt < 1500) {
      return;
    }
    this.lastAlertSoundAt = now;
    this.alertAudio.currentTime = 0;
    this.alertAudio.play().catch(() => {
    });
  }


viewAlert(alert: any) {
  this.alertService.openAlertDetail(alert);
  this.route.navigate([RoutesEnum.EQUIPMENT_ALERT]);
}

viewAllAlerts() {
  this.route.navigate([RoutesEnum.EQUIPMENT_ALERT]);
}

  onAlertPanelShow() {
    this.alertPanelOpen = true;
    this.badgeCount = 0;
    this.alertBlinking = false;
  }

  onAlertPanelHide() {
    this.alertPanelOpen = false;
  }
}
